import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Register our custom font-size tokens (defined in tailwind.config.js → theme.extend.fontSize)
// so they don't get treated as colors by twMerge. Without this, `cn("text-body-sm", "text-white")`
// silently drops `text-white` because both are seen as `text-*` color utilities.
const customMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["display", "display-lg", "h1", "h2", "h3", "h4", "body", "body-sm", "caption", "eyebrow", "code"] },
      ],
    },
  },
});

export function cn(...inputs) {
  return customMerge(clsx(inputs));
}
